import { compose } from 'recompose';
import FavoriteProjects from './favoriteProjects';

const enhance = compose(
);
export default enhance(FavoriteProjects);
